<template>
	<div>
		<div class="btn-wrap">
			<el-button type="primary" @click="onBtnClick('commission')" :class="(orderInfo.order_status == '5' || orderInfo.order_status == '9')?'un_click':''">修改佣金</el-button>
			<el-button type="primary" @click="onBtnClick('progress')">添加进度</el-button>
		</div>
		<div class="order-code">订单编号： {{order_code}}</div>
		<div class="follow_record_wrap">
			<el-timeline>
                <template v-if="order_follow_records.length">
                    <el-timeline-item v-for="item in order_follow_records" :key="item.uuid" :timestamp="item.create_time">
                    	<div class="status">
                            <span v-if="item.is_admin_assist === '2'">求协助</span>
                            <template v-else>
                                <span v-if="item.is_add_user === '1'">商家说</span>
                                <span v-else-if="item.is_add_user === '2'">管理说</span>
                                <span v-else-if="item.is_add_user === '3'" class="status_p">
                                	<span v-if="item.order_status === '1'">待付款</span>
                                	<span v-if="item.order_status === '2'">待处理</span>
                                	<span v-if="item.order_status === '3'&&item.is_admin_assist!=='2'">处理中</span>
                                	<span v-if="item.order_status === '4'">待确认</span>
                                	<span v-if="item.order_status === '5'">已完成</span>
                                	<span v-if="item.order_status === '13'">已撤回</span>
                                	<span v-if="item.order_status === '7'">已取消</span>
                                	<span v-if="item.order_status === '8'">已驳回</span>
                                	<span v-if="item.order_status === '9'">已退款</span>
                                	<span v-if="item.order_status === '10'">退款中</span>
                                	<span v-if="item.order_status === '11'">未解决</span>
                                </span>
                            </template>
                    	</div>
                    	<!-- <span :class="{record_tag: item.tag}">{{item.tag}}</span> -->
                    	<div>{{item.content}}<span v-if="item.type === '2'" class="warn">(仅内部可见)</span></div>
                    	<viewer :images="item.img">
                    		<img v-for="src in item.img" :src="imgDomain + src" :key="src" style="width: 80px; height: 80px">
                    	</viewer>
                    </el-timeline-item>
                </template>

                <el-timeline-item v-if='orderInfo.order_status!=1'>
                	<div class="status">
                		<span>已付款</span>
                	</div>
                	<div>订单已付款，正在处理</div>
                </el-timeline-item>
                
                <el-timeline-item>
                	<div class="status">
                		<span>待付款</span>
                	</div>
                	<div>订单未支付款项，等待付款</div>
                </el-timeline-item>
			</el-timeline>
		</div>
		<common-dialog :title="dialogTitle" :dialogVisible="folowRecordVisible" :showClose="true" @dialog-close="dialogClose"
		 @cancel="folowRecordVisible = false" @confirm="dialogConfirmClick">
			<div v-if="dialogType === 'commission'" class="commission">
				<div class="input-wrap">
					<span>订单佣金比例修改为</span>
					<el-input v-model="commission_rate" placeholder="请输入佣金" class="input"></el-input>
					<span>%</span>
				</div>
				<div class="tip">
					<div>原佣金： ¥{{orderInfo.commission_price}}</div>
					<div>订单价格： ¥{{orderInfo.order_server_price}}</div>
				</div>
			</div>
			<div v-if="dialogType === 'progress'" class="commission">
				<el-input type="textarea" :rows="3" maxlength="500" show-word-limit placeholder="请输入内容" v-model="content">
				</el-input>
				<div class="img-wrap">
					<label>上传图片</label>
					<imageUpload v-model="img" :limit="6" />
				</div>
				<div>
					<span>用户是否可见:</span>
					<el-switch v-model="is_visible" active-color="#13ce66" inactive-color="#999999">
					</el-switch>
				</div>
			</div>
		</common-dialog>
	</div>
</template>

<script>
	import {
		changeorder,
		orderFollowRecord,
		orderDetail,
		addRecord
	} from "@/api/order";
	import {
		mapState
	} from "vuex";
	import CommonDialog from "@/components/CommonDialog";
	import imageUpload from "@/components/ImageUpload";

	export default {
		data() {
			return {
				order_follow_records: [],
				order_code: "",
				folowRecordVisible: false,
				dialogTitle: "",
				dialogType: "",
				orderInfo: {},
				commission_rate: "",
				uuid: "",
				img: [],
				is_visible: false,
				content: ""
			};
		},
		components: {
			CommonDialog,
			imageUpload
		},
		async mounted() {
			const {
				uuid,
				order_code
			} = this.$route.query;
			if (uuid) {
				this.order_code = order_code;
				this.uuid = uuid;
				this.getRecord(uuid);
				this.getOrderDetail(uuid);
			}
		},
		computed: {
			...mapState(["imgDomain"])
		},
		methods: {
			async getOrderDetail(uuid) {
				const {
					data,
					status
				} = await orderDetail(uuid);
				if (status !== 200) return;
				this.orderInfo = data;
				this.commission_rate = data.commission_rate * 100;
			},
			async getRecord(uuid) {
				const {
					data,
					status
				} = await orderFollowRecord({
						page_index: 1,
						page_size: 99
					},
					uuid
				);
				//有数据时才更新store数据
				this.order_follow_records = data.data;
				console.log(data, "record");
			},
			dialogClose() {
				this.folowRecordVisible = false;
				this.getRecord(this.uuid);
				this.getOrderDetail(this.uuid);
			},
			onBtnClick(type) {
				if(type === "progress"){
					this.dialogType = type;
					this.dialogTitle =  "添加进度";
					this.folowRecordVisible = true;
				}
				else{
					if(this.orderInfo.order_status != '5' && this.orderInfo.order_status != '9'){
						this.dialogTitle =  "修改佣金";
						this.dialogType = type;
						this.folowRecordVisible = true;
					}
				}
			},
			async dialogConfirmClick() {
				switch (this.dialogType) {
					case "commission":
						{
							if (!this.commission_rate) {
								this.$message("佣金比例不能为空");
								return;
							}
							if (
								this.commission_rate < 1 ||
								this.commission_rate > 100 ||
								this.commission_rate % 1 !== 0
							) {
								this.$message("佣金比例必须为1到100范围的整数");
								return;
							}
							let postData = {
								type: "12",
								commission_rate: this.commission_rate / 100
							};
							const {
								status
							} = await changeorder(postData, this.uuid);
							if (status === 200) this.folowRecordVisible = false;
						}
						break;
					case "progress":
						if (!this.content) {
							this.$message("内容不能为空");
							return;
						}
						let type = this.is_visible ? "1" : "2";
						let postData = {
							content: this.content,
							is_admin: "1",
							img: this.img,
							type
						};
						const {
							status
						} = await addRecord(postData, this.uuid);
						if (status === 200) this.folowRecordVisible = false;
						this.content = '';
						this.img = [];
						this.is_visible = false;
				}
			}
		}
	};
</script>

<style lang='less' scoped>
	.un_click{
		background: #ccc;
		border: 1px solid #ccc;
	}
	.order-code {
		margin: 20px 0;
	}

	.follow_record_wrap {
		text-align: left;

		.record_tag {
			display: inline-block;
			text-align: center;
			max-width: 150px;
			width: auto;
			padding: 5px 10px;
			border: 1px solid #000;
			border-radius: 5px;
		}
        .status{
            .status_p{
                display: inline-block;
                width: 50px;
            }
        }
	}

	/deep/.el-timeline-item__wrapper {
		.status {
			position: absolute;
			top: 0;
			left: -50px;
		}
	}

	.commission {
		.input-wrap {
			display: flex;
			align-items: center;

			.input {
				width: 150px;
			}
		}
	}

	.tip {
		margin-top: 50px;
		color: #999;
		line-height: 30px;
	}

	.img-wrap {
		margin: 30px 0;
	}

	.warn {
		color: orange;
	}
</style>
